/*
 * @Author: jiangxd
 * @Date: 2021-08-04 11:24:02
 * @LastEditTime: 2021-08-04 11:44:23
 * @LastEditors: jiangxd
 * @Description:
 * @FilePath: /rs_ips_maintence/src/views/components/shopDisplaySketchMap/displayEdit/productPicture.tsx
 */
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import style from './style.vue';
import Upload from '@/views/components/upload/upload.vue';

@Component({
  components: { Upload },
  mixins: [style],
})
export default class ProductPicture extends Vue {
  @Prop({ default: () => {} })
    value: ItemObject;

  @Prop({ default: false })
    disabled: boolean;

  data: ItemObject = {};

  @Watch('value', { deep: true, immediate: true })
  watchValue(n, o) {
    if (JSON.stringify(n) !== JSON.stringify(o)) {
      this.data = n;
    }
  }

  uploadSuccess(res: HttpAPIRetItem<any>) {
    this.data.desc.imageUrl = res.content;
    this.$emit('input', this.data);
  }

  render(h) {
    return (
      <el-form props={{ model: this.data }} ref="form" class="pro-picture" show-message={false} disabled={this.disabled}>
        <el-form-item prop="desc.imageUrl" rules={{ required: true, trigger: 'change' }}>
          <div class="r-mx-20 r-my-10">
            <Upload noDelete={false} onImgUploadSuccess={val => this.uploadSuccess(val)} img={this.value.desc.imageUrl} maxSize={1024} disabled={this.disabled} />
            <div class="tip line-height-24">注1: 图片将在所有商品详情中设定的位置上固定显示;</div>
            <div class="tip line-height-24">注2: 建议图片宽度为750px,大小不超过1M;</div>
            <div class="tip line-height-24">注3: 图片支持拖动排序,可拖拽到主图下,价格模块下,参数模块下,商详图片下;</div>
          </div>
        </el-form-item>
      </el-form>
    );
  }
}
